import { ChangeDetectorRef, Component, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory } from 'survey-angular-ui';
import { RendererFactory } from 'survey-core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { PaymentFormCreditCardWidgetModel } from './payment-form-credit-card.widget.model';
import { PaymentFormWidgetService } from '../services/payment-form.widget.service';
import { VariablesService } from '../../../../../core/services/survey/variables.service';
import { PaymentFormCreditCardWidgetJson } from './payment-form-credit-card.widget.json';
import { StringUtils } from '@tangilla/tg-ng-common';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { SnackbarService } from '@tangilla/tg-ng-core';
import { QuestionsService } from '../../../../../core/services/survey/questions.service';
import { TangillaQuestion } from '../../tangilla-question';
import { CreditCardValidators } from 'angular-cc-library';

@Component({
  selector: 'tgf-payment-form-credit-card-widget',
  templateUrl: './payment-form-credit-card.widget.component.html',
  styleUrls: ['./payment-form-credit-card.widget.component.scss']
})
export class PaymentFormCreditCardWidgetComponent extends TangillaQuestion<PaymentFormCreditCardWidgetModel> {
  totalCharge = this.variablesService.totalCharges;
  charges = this.variablesService.charges;
  isLoading = false;
  isLoadingPayment = false;

  paymentFormCreditCardWidgetJson = new PaymentFormCreditCardWidgetJson();

  questionJson: any;

  constructor(
    public paymentFormWidgetService: PaymentFormWidgetService,
    public variablesService: VariablesService,
    private snackbarService: SnackbarService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(formBuilder, surveyService, questionsService, changeDetectorRef, viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.scrollTopOnFormInvalid = true;
    this.initForm();
  }

  initForm() {
    this.addCreditCardFormControls();
    this.questionJson = this.paymentFormCreditCardWidgetJson.getWidgetJson(this.questionForm!);
    this.questionForm.valueChanges.subscribe(data => {
      this.changeDetectorRef.detectChanges();
    });
  }

  getAddressFormModel() {
    const model = {
      jsonObj: {
        namesReplacements: {
          addressLine1: 'ccaddress1',
          addressLine2: '',
          state: 'ccstate',
          city: 'cccity',
          zip5: 'cczip'
        },
        labelsReplacements: {
          addressLine1: 'Address',
          addressLine2: '',
          state: 'State',
          city: 'City',
          zip5: 'Zip'
        },
        defaultValueQuestionNames: {
          addressLine1: 'h_address1',
          state: 'h_state',
          city: 'h_city',
          zip5: 'h_zip'
        },
        includeInOutputFields: {
          addressLine1: false,
          addressLine2: false,
          state: false,
          city: false,
          zip5: false
        },
        excludeFields: [
          'addressLine2',
        ],
      }
    };
    return model as any;
  }

  addCreditCardFormControls() {
    this.addCreditCardFormControl('terms_of_payment');
    this.addCreditCardFormControl('expiration_date', [Validators.required, CreditCardValidators.validateExpDate]);
    this.addCreditCardFormControl('card_number', [Validators.required, CreditCardValidators.validateCCNumber]);
    this.addCreditCardFormControl('name_on_card');
  }

  makePayment() {
    const that = this;
    this.submitForm(() => that.doMakePayment());
  }

  async doMakePayment() {
    if (this.surveyService.isPreview) {
      this.snackbarService.error('No payments allowed in preview mode');
      this.changeDetectorRef.detectChanges();
      return;
    }
    if (!this.surveyService.surveyModel.activePage?.hasErrors()) {
      await this.processPayment();
    }
  }

  async processPayment() {
    this.isLoadingPayment = true;
    this.changeDetectorRef.detectChanges();

    const paymentPayload = this.paymentFormWidgetService.getPaymentPayload([this.charges], 'recn');
    const body = this.formToEntity();

    try {
      await this.paymentFormWidgetService.doMakePayment(body, paymentPayload, this.charges.billing_year, 'recn', this.charges.create_cco_record);
    } catch (error: any) {
    } finally {
      this.isLoadingPayment = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  formToEntity() {
    const formValue = this.questionForm.getRawValue();

    return {
      ...formValue,
      number: formValue.card_number,
      nameOnCard: formValue.name_on_card,
      expiryDate: formValue.expiration_date,
      primaryCard: false,
      addressLine1: formValue.addressLine1,
      state: formValue.state,
      city: formValue.city,
      zip: formValue.zip5,
      saveInPaymentMethods: false
    };
  }

  addCreditCardFormControl(controlName: string, validators: Array<any> = [Validators.required]) {
    this.questionForm.addControl(controlName, new FormControl(null, validators));
  }

  isItLoading() {
    return this.isLoading ||
      this.isLoadingPayment;
  }

  protected readonly StringUtils = StringUtils;
}

RendererFactory.Instance.registerRenderer(
  'payment_form_credit_card',
  'payment_form_credit_card',
  'tg_payment_form_credit_card',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_payment_form_credit_card', PaymentFormCreditCardWidgetComponent);
